<div class="w-full h-full">
  <div class="m-1 fixed z-50">
    <button mat-raised-button color="primary" (click)="toggleStyle()">Toggle Style</button>
  </div>
  <div #map class="w-full h-full fixed"></div>
</div>
